import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabase';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser]               = useState(null);
  const [subscription, setSubscription] = useState(null); // ← NEW
  const [loading, setLoading]         = useState(true);

  // ── NEW: fetch subscription tier from users table ─────────────────────────
  async function fetchSubscription(userId) {
    const { data } = await supabase
      .from('users')
      .select('subscription')
      .eq('id', userId)
      .maybeSingle();
    setSubscription(data?.subscription ?? null);
  }

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(async ({ data: { session } }) => { // ← async added
      setUser(session?.user ?? null);
      if (session?.user) await fetchSubscription(session.user.id);     // ← NEW
      setLoading(false);
    });

    // Listen for auth changes
    const { data: { subscription: authListener } } = supabase.auth.onAuthStateChange( // ← renamed to avoid clash
      async (event, session) => {
        setUser(session?.user ?? null);
        setLoading(false);

        // Clean URL after OAuth redirect
        if (event === 'SIGNED_IN' && window.location.hash.includes('access_token')) {
          window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Save user to users table on sign in
        if (event === 'SIGNED_IN' && session?.user) {
          await supabase.from('users').upsert({
            id:         session.user.id,
            email:      session.user.email,
            name:       session.user.user_metadata?.full_name || '',
            avatar_url: session.user.user_metadata?.avatar_url || '',
          }, { onConflict: 'id' });

          await fetchSubscription(session.user.id); // ← NEW
        }

        if (event === 'SIGNED_OUT') setSubscription(null); // ← NEW
      }
    );

    return () => authListener.unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, subscription, loading }}> {/* ← subscription added */}
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);